import { post, get } from '@/services/http';

export class LoginRequestModel {
  public id?: string;
  public merchantId: number;
  public customerId: string;
  public agentId: string;
  public agentName: string;
  public agentEmail: string;
  public reason: string;
  public status?: string;
  public requestedAt?: string;
  public respondedAt?: string;
  public expiresAt?: string;
  public accessDurationHours?: number;
  public isExpired?: boolean;

  constructor(data: any = {}) {
    this.id = data.id;
    this.merchantId = data.merchantId || data.merchant_id;
    this.customerId = data.customerId || data.customer_id || '';
    this.agentId = data.agentId || data.agent_id || '';
    this.agentName = data.agentName || data.agent_name || '';
    this.agentEmail = data.agentEmail || data.agent_email || '';
    this.reason = data.reason || '';
    this.status = data.status;
    this.requestedAt = data.requestedAt || data.requested_at;
    this.respondedAt = data.respondedAt || data.responded_at;
    this.expiresAt = data.expiresAt || data.expires_at;
    this.accessDurationHours = data.accessDurationHours || data.access_duration_hours || 24;
    this.isExpired = data.isExpired || data.is_expired;
  }

  public async create() {
    const res: any = await post(`/login-requests`, {
      merchant_id: this.merchantId,
      customer_id: this.customerId,
      agent_id: this.agentId,
      agent_name: this.agentName,
      agent_email: this.agentEmail,
      reason: this.reason,
      access_duration_hours: this.accessDurationHours,
    });
    const data = res?.data ?? res;
    if (data && typeof data === 'object') {
      this.mapData(data);
    }
  }

  public async checkStatus() {
    if (!this.id) {
      throw new Error('Request ID is required');
    }
    const res: any = await get(`/login-requests/${this.id}`);
    const data = res?.data ?? res;
    if (data && typeof data === 'object') {
      this.mapData(data);
    }
  }

  public mapData(data: any = {}) {
    this.id = data.id;
    this.merchantId = data.merchantId || data.merchant_id;
    this.customerId = data.customerId || data.customer_id;
    this.agentId = data.agentId || data.agent_id;
    this.agentName = data.agentName || data.agent_name;
    this.agentEmail = data.agentEmail || data.agent_email;
    this.reason = data.reason;
    this.status = data.status;
    this.requestedAt = data.requestedAt || data.requested_at;
    this.respondedAt = data.respondedAt || data.responded_at;
    this.expiresAt = data.expiresAt || data.expires_at;
    this.accessDurationHours = data.accessDurationHours || data.access_duration_hours;
    this.isExpired = data.isExpired || data.is_expired;
  }
}
